import { FormControl, FormLabel } from "@chakra-ui/react";
import React, {ChangeEvent, forwardRef, useImperativeHandle, useRef, useState} from "react";
import { Box } from '@chakra-ui/react';
import InputNumber from "./NumberInputField";


interface InputNumberProps {
    label: string;
}

export class NumberDate {
    constructor(public day: number|null, public month: number|null, public year: number|null) {}
}

const InputNumberDate = forwardRef((props: InputNumberProps, ref) => {

    const [day, setDay] = useState<number|null>(null);
    const [month, setMonth] = useState<number|null>(null);
    const [year, setYear] = useState<number|null>(null);

    useImperativeHandle(ref, () => ({
        day () { return day },
        month () { return month },
        year () { return year }
    }));

    return (
        <FormControl
                     mt="5"
        >
            <FormLabel>{props.label}</FormLabel>
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                gap={1}
            >
                <InputNumber 
                    defaultValue={30}
                    min={1}
                    max={31}
                    onChange={(value: number | null) => setDay(value)}
                />
                <InputNumber
                    defaultValue={12}
                    min={1}
                    max={12}
                    onChange={(value: number | null) => setMonth(value)}
                />
                <InputNumber
                    defaultValue={2020}
                    min={1900}
                    max={2100}
                    onChange={(value: number | null) => setYear(value)}
                />
            </Box>
        </FormControl>
    );
});

export default InputNumberDate;